import React from 'react';

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log the error to a server-side error tracking tool
    console.log(error);
  }

  render() {
    if (this.state.hasError) {
      // Show a user-friendly error message
      return <p style={{padding: 16}}>An error has occurred. Please refresh the page.</p>;
    }

    // Render the wrapped component
    return this.props.children;
  }
}
